import { render } from "./CustomTextArea.vue?vue&type=template&id=5e9ce595&scoped=true"
import script from "./CustomTextArea.vue?vue&type=script&lang=js"
export * from "./CustomTextArea.vue?vue&type=script&lang=js"

import "./CustomTextArea.vue?vue&type=style&index=0&id=5e9ce595&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9ce595"]])

export default __exports__